import { render, staticRenderFns } from "./medicion-mortalidad.vue?vue&type=template&id=3fbfba6c&scoped=true&"
import script from "./medicion-mortalidad.vue?vue&type=script&lang=js&"
export * from "./medicion-mortalidad.vue?vue&type=script&lang=js&"
import style0 from "./medicion-mortalidad.vue?vue&type=style&index=0&id=3fbfba6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbfba6c",
  null
  
)

export default component.exports